import React, { useContext } from "react";
import { SwiperSlide } from "swiper/react";
import Rating from "@atoms/Rating";
import Section from "@atoms/Section/Section";
import Text from "@atoms/Text/Text";
import Title from "@atoms/Title/Title";
import CardSlider from "@components/CardSlider/CardSlider";
import AudioPlayer from "@atoms/AudioPlayer/AudioPlayer";
import Icon from "@atoms/Icon/Icon";
import { Box } from "@material-ui/core";
import "./SocialProof.scss";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { ModalContext } from "@context/modal";
import { ContainerType, DialogMode } from "../../context/modal/ModalContext";
import DialogContent from "../../atoms/Dialog/DialogContent";
import { CgClose } from "react-icons/cg";
import Button from "../../atoms/Button/Button";
import Img from "gatsby-image";

type Comment = {
	text: string;
};

interface Props {
	quote?: string;
	author?: string;
	comments: Comment[];
	audioUrl?: string;
	audioMoreInfo?: any;
}

const SocialProof: React.FC<Props> = ({
	quote,
	author,
	comments,
	audioUrl,
	audioMoreInfo,
}) => {
	const { showModal, hideModal } = useContext(ModalContext);

	const showAudioModalLearnMore = () => {
		if (!audioMoreInfo) return;
		const { component } = audioMoreInfo;
		if (component && component.length > 0) {
			const data = component[0];
			showModal(
				<DialogContent>
					<Box sx={{ p: 2, position: "relative" }}>
						<div className="DialogFullHeader--right">
							<Button
								size="l"
								variant="inline"
								label={<CgClose size="22" />}
								onClick={hideModal}
							/>
						</div>
					</Box>
					<Box
						sx={{
							width: "100%",
							maxWidth: "150px",
							margin: "0 auto",
						}}
					>
						{data.image && (
							<Img
								fluid={data.image.urlSharp.childImageSharp.fluid}
								alt="chapter-audio-learn-more"
							/>
						)}
					</Box>

					<Section spacingTop="xs">
						<Title size="m" align="center">
							{data.title}
						</Title>
						<Text size="m" align="center">
							{data.content}
						</Text>
					</Section>
				</DialogContent>,
				{
					mode: DialogMode.Custom,
					container: ContainerType.tiny,
					className: "ChapterAudioLearnMoreModal",
				},
			);
		}
	};

	return (
		<Section
			theme="dark"
			spacingBottom="l"
			spacingTop="s"
			className="SocialProof"
		>
			<Section container="large">
				<Section spacingTop="m" className="SocialProof--quote">
					<Title tag="p" size="xl" theme="white" align="center">
						“{quote}”
					</Title>
					<Text size="m" theme="white" align="center">
						{author}
					</Text>
				</Section>
				{audioUrl && (
					<Section spacing="s">
						<div className="SocialProof--audioWrapper">
							<Box className="SocialProof--audio">
								<AudioPlayer src={audioUrl} name="SocialProofAudio" />
							</Box>
							{audioMoreInfo && (
								<Box sx={{ ml: 2 }} className="audioInfoBoxButton">
									<Icon
										icon={<AiOutlineInfoCircle />}
										theme="white"
										size="xs"
										onClick={showAudioModalLearnMore}
									/>
								</Box>
							)}
						</div>
					</Section>
				)}
			</Section>
			<Section spacingTop="m">
				<div className="g_clearfix g_center UserReviewBlock">
					<CardSlider
						sliderOption={{
							autoplay: true,
							allowSlidePrev: true,
							allowSlideNext: true,
							centeredSlides: true,
							initialSlide: 0,
							slidesPerView: 1.3,
							breakpoints: {
								600: {
									slidesPerView: 1.99,
								},
								1001: {
									centeredSlides: false,
									slidesPerView: 4,
									allowSlidePrev: false,
									allowSlideNext: false,
								},
							},
						}}
					>
						{comments.map((item: any, index: number) => (
							<SwiperSlide
								key={`comments_${index}`}
								className="UserReviewBlock--item"
							>
								<Rating />
								<Text size="m" theme="white" align="center">
									“{item.text}”
								</Text>
							</SwiperSlide>
						))}
					</CardSlider>
				</div>
			</Section>
		</Section>
	);
};

export default SocialProof;
